import { apiClient } from "@/ultis/apiClient";
import tv360StoreMockup from "@/store/mock/tv360StoreMock";
//const controller = "wing-tv360";
const controller = "tv360";

const mockTimeOut = 1000;
const isDev = false; 
export const actions = {
  async getListPackage({ commit }, params) {
    if (isDev) {
      console.log("[TV360-Store] getListPackage Mockup Data");
      await new Promise((r) => setTimeout(r, mockTimeOut));
      return tv360StoreMockup.getListPackage();
      //return apiClient.post(controller + "/getAll", params);
    } else {
      return apiClient.post(controller + "/getTV360Packages", params);
    }
  },

  async preBuyPackageTv360ABA({ commit }, params) {
    if (isDev) {
      console.log("[TV360-Store] preBuyPackageTv360ABA Mockup");
      await new Promise((r) => setTimeout(r, mockTimeOut));
      return tv360StoreMockup.preBuyPackageTv360ABA(params);
    } else {
      return apiClient.post(controller + "/preBuyPackageTv360ABA", params);
    }
  },

  async checkPaymentStatusABA({ commit }, params) {
    if (isDev) {
      console.log("[TV360-Store] checkPaymentStatusABA Mockup");
      await new Promise((r) => setTimeout(r, mockTimeOut));
      return tv360StoreMockup.checkPaymentStatusABA(params);
    } else {
      return apiClient.post("metfoneServices/checkPaymentStatusABA", params);
    }
  },

  async buyPackageTv360ABA({ commit }, params) {
    if (isDev) {
      console.log("[TV360-Store] buyPackageTv360ABA Mockup Data");
      await new Promise((r) => setTimeout(r, mockTimeOut));
      return tv360StoreMockup.buyPackageTv360ABA(params);
    } else {
      return apiClient.post(controller + "/buyPackageTv360ABA", params);
    }
  },

  async getHistoryPackageTV360({ commit }, params) {
    if (isDev) {
      console.log("[TV360-Store] getHistoryPackageTV360 Mockup Data");
      await new Promise((r) => setTimeout(r, mockTimeOut));
      return tv360StoreMockup.getHistoryPackageTV360(params);
    } else {
      return apiClient.post(controller + "/getHistoryPackageTV360", params);
    }
  },

  async syncTransT360({ commit }, params) {
    if (isDev) {
      console.log("[TV360-Store] syncTransT360 Mockup Data");
      await new Promise((r) => setTimeout(r, mockTimeOut));
      return tv360StoreMockup.syncTransT360(params);
    } else {
      return apiClient.post("tv360/syncTransT360", params);
    }
  },

  ///================================================================================

  // Không còn dùng
  async getDetailPackage({ commit }, params) {
    return apiClient.post("metfoneServices/getDetail", params);
  },

  async getListMyService({ commit }, params) {
    return apiClient.post("users/myServices", params);
  },

  //
  async get({ commit }) {
    return apiClient.get(controller);
  },

  async buyPackage({ commit }, params) {
    return apiClient.post("packages/buy", params);
  },

  async genRequestId({ commit }, params) {
    return apiClient.post("transaction/gen-request-id", params);
  },
  async getISDN({ commit }, params) {
    return apiClient.post("users/isdn", params);
  },
  async getHashPayment({ commit }, params) {
    return apiClient.post("metfoneServices/genHashDoPayment", params);
  },

  async getCurrentUsedServiceDetail({ commit }, params) {
    return apiClient.post("users/myServices/detail", params);
  },
};
